<template>
  <canvas
    ref="confettiCanvas"
    :width="canvasSize"
    :height="canvasSize"
    class="confetti-animation"
  ></canvas>
</template>

<script>
export default {
  name: 'ConfettiExplosion',
  props: {
    canvasSize: {
      type: Number,
      default: 150,
    },
    eyeRadius: {
      type: Number,
      default: 10,
    },
    particleSize: {
      type: Number,
      default: 3,
    },
    particleCount: {
      type: Number,
      default: 100,
    },
    repeatCount: {
      type: Number,
      default: 3,
    },
    animationDuration: {
      type: Number,
      default: 2000,
    },
    delayBetweenAnimations: {
      type: Number,
      default: 1000,
    },
  },
  data() {
    return {
      confettiParticles: [],
      canvasContext: null,
      animationFrameId: null,
      currentRepeat: 0,
    }
  },
  mounted() {
    this.initializeCanvas()
    this.startConfetti()
  },
  methods: {
    initializeCanvas() {
      const canvas = this.$refs.confettiCanvas
      this.canvasContext = canvas.getContext('2d')
    },
    startConfetti() {
      this.currentRepeat = 0
      this.runAnimation()
      this.animate()
    },
    runAnimation() {
      this.generateParticles()

      setTimeout(() => {
        this.currentRepeat++
        if (this.currentRepeat < this.repeatCount) {
          setTimeout(() => {
            this.runAnimation()
          }, this.delayBetweenAnimations)
        }
      }, this.animationDuration)
    },
    generateParticles() {
      for (let i = 0; i < this.particleCount; i++) {
        const particle = this.createParticle()
        const delay = Math.random() * this.animationDuration
        setTimeout(() => {
          this.confettiParticles.push(particle)
        }, delay)
      }
    },
    createParticle() {
      const colors = [
        '#DDA0DD',
        '#FF69B4',
        '#FF1493',
        '#C71585',
        '#8B008B',
        '#FFFF00',
        '#00BFFF',
      ]
      const angle = Math.random() * 2 * Math.PI
      const speed = Math.random() * 1.5 + 0.5

      const radius =
        this.eyeRadius + Math.random() * (this.canvasSize / 2 - this.eyeRadius)

      return {
        x: this.canvasSize / 2 + Math.cos(angle) * radius,
        y: this.canvasSize / 2 + Math.sin(angle) * radius,
        color: colors[Math.floor(Math.random() * colors.length)],
        size: Math.random() * this.particleSize + this.particleSize / 2,
        velocityX: Math.cos(angle) * speed,
        velocityY: Math.sin(angle) * speed,
        rotation: Math.random() * 360,
        rotationSpeed: Math.random() * 5 - 2.5,
      }
    },
    animate() {
      this.canvasContext.clearRect(0, 0, this.canvasSize, this.canvasSize)

      this.confettiParticles = this.confettiParticles.filter(particle => {
        particle.x += particle.velocityX
        particle.y += particle.velocityY
        particle.rotation += particle.rotationSpeed

        const isVisible =
          particle.x >= 0 &&
          particle.x <= this.canvasSize &&
          particle.y >= 0 &&
          particle.y <= this.canvasSize

        if (isVisible) {
          this.drawParticle(particle)
        }

        return isVisible
      })

      this.animationFrameId = requestAnimationFrame(this.animate)
    },
    drawParticle(particle) {
      this.canvasContext.save()
      this.canvasContext.translate(particle.x, particle.y)
      this.canvasContext.rotate((particle.rotation * Math.PI) / 180)
      this.canvasContext.fillStyle = particle.color
      this.canvasContext.fillRect(
        -particle.size / 2,
        -particle.size / 2,
        particle.size,
        particle.size
      )
      this.canvasContext.restore()
    },
    stopAnimation() {
      cancelAnimationFrame(this.animationFrameId)
    },
    beforeDestroy() {
      this.stopAnimation()
    },
  },
}
</script>

<style lang="scss" scoped>
.confetti-animation {
  pointer-events: none;
  border-radius: 50%;
}
</style>
